import React from 'react'
import { Code } from 'screens/Code'

// License notation

// sass/node-sass
// Copyright (c) 2013-2016 Andrew Nesbitt
// Released under the MIT license
// https://github.com/sass/node-sass/blob/master/LICENSE

// facebook/react
// Copyright (c) Facebook, Inc. and its affiliates.
// Released under the MIT license
// https://github.com/facebook/react/blob/master/LICENSE

// create-react-app
// Copyright (c) 2013-present, Facebook, Inc.
// Released under the MIT license
// https://github.com/facebook/create-react-app/blob/master/LICENSE

// duskload/react-device-detect
// Copyright (c) 2017 duskload
// Released under the MIT license
// https://github.com/duskload/react-device-detect/blob/master/LICENSE

// microsoft/TypeScript
// Copyright (c) Microsoft Corporation
// Released under the Apache License 2.0
// https://github.com/microsoft/TypeScript/blob/master/LICENSE.txt

export const App = () => {
  return <Code />
}
